import React from 'react';
import { RideGrid } from '@rimac-seguros/ride-system-components';
import DynamicIcon from '@/components/atoms/DynamicIcon/index';
import './styles.scss';

const SectionGoals = (props) => {

  const { goals, title } = props;
  return (
    <div className="section-goal">
      <RideGrid>
        <h2 className="section-goal_title">{title}</h2>
        <div className="section-goal_cards-content">
          {goals.map((item, index) =>
            <div key={index} className="section-goal_card">
                <DynamicIcon icon={item.icon} size="medium" />
                <h3>{item.amount}</h3>
                <p>{item.goal}</p>
            </div>
          )}
        </div>
      </RideGrid>
    </div>
  )
};

export default SectionGoals;